<template>
  <div id="drive">
    <b-container fluid>
      <h1>Drive</h1>
      <div class="text-center">
        <b-form inline>
          <b-label>Document Type: </b-label>
          <b-select class="ml-2 w-25"
            size="sm"
            id="document-type-select"
            v-model="documentType" 
            :options="documentTypeOptions"
          ></b-select>
        </b-form>
      </div>
      <b-button 
        v-if="user.role == 'admin'"
        variant="success" 
        @click="displayUploadPanel()">
        Add
      </b-button>

      <div v-for="(file, index) in displayedFiles" :key="index">
        <div v-if="file.fileType == documentType">
          <b-row class="mt-1 ml-1" align-h="between">
            <div>
              <b-icon
                v-if="user.role == 'admin'"
                class="mt-1 pointer"
                icon="trash-fill"
                scale="1"
                variant="danger"
                @click="deleteFile(index)">
              </b-icon>
              <span style="color: green; cursor: pointer;text-decoration: underline;" @click="downloadFile(index)">{{ file.fileName }}</span>
              <span v-if="file.uploader != null" style="color: grey;">uploaded by {{ file.uploader }} [{{  file.fileType }}]</span>
            </div>
            
          </b-row>
          <hr class="m-0 p-0" />
        </div>
      </div>

      <b-modal
        id="modal-upload-file"
        hide-footer
        title="Upload File">

        <div class="fileUploadPanel">
          <b-form>

            <b-label><span style="color: red">*</span>Document Type: </b-label>
            <b-select
              required
              size="sm"
              id="document-type-select"
              v-model="uploadDocumentType" 
              :options="documentTypeOptions"
            ></b-select>

            <b-form-file
              class="mt-3"
              v-model="selectedFile"
              :state="Boolean(selectedFile)"
              placeholder="Choose files or drop those here..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
            <div class="mt-3">
              Selected files: {{ this.selectedFiles.length }}
            </div>
            <div>
              <b-row
                class="mt-1 ml-1"
                v-for="(file, index) in selectedFiles"
                :key="index"
              >
                {{ file.name }}
                <b-icon
                  class="mt-1 ml-1 pointer"
                  icon="x-circle"
                  scale="1"
                  variant="danger"
                  @click="removeFile(index)"
                ></b-icon>
              </b-row>
              
            </div>
            <b-button
              type="submit"
              :disabled="
                this.selectedFiles.length == 0 || this.isUploadingFile
                  ? true
                  : false
              "
              class="mt-4"
              block
              variant="success"
              @click="uploadFiles(uploadDocumentType)">
              Upload
            </b-button>
          </b-form>
        </div>
      </b-modal>

      <b-modal
        id="file-deletion-confirmation"
        hide-footer
        title="You are deleting a file"
      >
        <p>This file will be permanently deleted.</p>
        <div class="modal-footer">
          <b-button @click="hideModal('file-deletion-confirmation')">
            Cancel
          </b-button>
          <b-button variant="danger" @click="deleteFileTask"> Delete </b-button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: "Drive",
  data() {
    return {
      deletedFileIndex: 0,
      driveFiles: [],
      globalParameters: {},
      documentType: "",
      documentTypeOptions: [
        'Cemetery Plan - ADM',
        'Cemetery Plan - ALM',
        'Cemetery Plan - ASM',
        'Cemetery Plan - DM',
        'Cemetery Plan - LM',
        'Cemetery Plan - SM',
        'Price List',
        'Permit Fee',
        'Contract',
        'Others',
      ],
      uploadDocumentType: "",
      selectedFile: null,
      selectedFiles: [],
      uploadedDriveFileNames: [],
      uploadedDriveFiles: [],
      today: "",
      isUploadingFile: false,
      drive: Object,
      displayedFiles: [],
    }
  },
  props: {
    user: Object,
  },
  watch: {
    selectedFile(newSelectedFile) {
      if (this.selectedFile != null) {
        this.selectedFiles.push(newSelectedFile);
      }
    },
    // documentType(newDocumentType) {
    //   this.displayedFiles = this.drive[newDocumentType];
    //   console.log(this.displayedFiles);
    // },
  },
  created() {

    const now = new Date();
    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const yyyy = now.getFullYear();
    this.today = yyyy + "-" + mm + "-" + dd;
    
    // firebase.firestore().collection('global_settings').doc('parameters').onSnapshot((snapshot) => {
    //   this.globalParameters = snapshot.data();
    //   this.documentTypeOptions = this.globalParameters.driveDocumentTypes;
    //   console.log(this.globalParameters);
    // });

    firebase.firestore().collection('drive').orderBy("fileName", "asc").onSnapshot((collection) => {
      // this.drive = new Object();
      this.driveFiles = collection.docs.map(doc => doc.data());
      this.displayedFiles = this.driveFiles;
      // this.driveFiles.forEach((element) => {
      //   if(this.drive[element.fileType] == null) {
      //     this.drive[element.fileType] = [];
      //   } else {
      //     this.drive[element.fileType].push(element);
      //     console.log(this.drive[element.fileType]);
      //   }
      // });
    });
  },
  methods: {
    downloadFile(index) {
      window.open(this.driveFiles[index].fileURL);
    },
    deleteFile(index) {
      this.deletedFileIndex = index;
      this.showModal("file-deletion-confirmation");
    },
    displayUploadPanel() {
      this.showModal('modal-upload-file');
      this.uploadDocumentType = this.documentType;
    },
    deleteFileTask() {
      const index = this.deletedFileIndex;
      var deletedFile = this.driveFiles[index];
      this.driveFiles.splice(index, 1);

      firebase.firestore().collection("drive").doc(deletedFile.id).delete();

      if (deletedFile.fileURL) {
        var storageRef = firebase.storage().ref();
        var desertRef = null;
        desertRef = storageRef.child(
          "Drive/" + deletedFile.fileType + "/" + deletedFile.fileName
        );

        // Delete the file
        desertRef
          .delete()
          .then(function() {})
          .catch(function(error) {
            alert(error);
          });
      }

      this.hideModal("file-deletion-confirmation");

    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
      this.selectedFile = null;
    },
    uploadFiles(type) {

      // Check if there is a identical file in the storage
      // for (var i = 0; i < this.selectedFiles.length; i++) {
      //   for (var c = 0; c < this.viewedOrder.files.length; c++) {
      //     if (this.selectedFiles[i].name == this.viewedOrder.files[c].fileName && ( this.viewedOrder.files[c].fileType != null && this.viewedOrder.files[c].fileType == type)) {
      //       console.log(this.selectedFiles[i].name + this.viewedOrder.files[c].fileName);
      //       alert("Do not upload duplicate file!");
      //       return;
      //     }
      //   }
      // }

      console.log("uploading starts");
      this.selectedFile = null;
      this.progress = 0;
      this.isUploading = true;
      this.isUploadingFile = true;

      if (this.selectedFiles.length > 0) {
        var storageRef = firebase.storage().ref();

        for (
          var fileIndex = 0;
          fileIndex < this.selectedFiles.length;
          fileIndex++
        ) {
          var fileName = this.selectedFiles[fileIndex].name;
          this.uploadedDriveFileNames.push(fileName);
        }

        // Assemble directory
        var directoryPrefix = "Drive/" + type + "/";

        for (
          var uploadedDriveFilesIndex = 0;
          uploadedDriveFilesIndex < this.driveFiles.length;
          uploadedDriveFilesIndex++
        ) {
          this.uploadedDriveFiles.push(this.driveFiles[uploadedDriveFilesIndex]);
        }

        this.uploadFileTask(storageRef, directoryPrefix, 0, type);
      }
    },
    uploadFileTask(storageRef, directoryPrefix, uploadedDriveFilesCount, fileType) {
      if (uploadedDriveFilesCount == this.selectedFiles.length) {
        this.uploadedDriveFiles.concat(this.driveFiles);

        this.driveFiles = this.uploadedDriveFiles;
        this.uploadedDriveFiles = [];
        this.selectedFiles = [];
        this.uploadedDriveFileNames = [];
        this.isUploadingFile = false;

        return;
      }

      const self = this;
      const uploadingFile = this.selectedFiles[uploadedDriveFilesCount];
      const uploadingTask = storageRef
        .child(directoryPrefix + uploadingFile.name)
        .put(uploadingFile, uploadingFile.type);
      //uploadingTasks.push(uploadingTask);
      uploadingTask.then((data) => {
        data.ref.getDownloadURL().then((url) => {
          const newFileRef = firebase
            .firestore()
            .collection("drive")
            .doc();

          const tempFile = {
            id: newFileRef.id,
            fileName: this.uploadedDriveFileNames[uploadedDriveFilesCount],
            fileURL: url,
            fileType: fileType,
            uploader: this.user.name,
            uploadDate: this.today,
          };
          self.uploadedDriveFiles.push(tempFile);
          ++uploadedDriveFilesCount;
          self.uploadFileTask(
            storageRef,
            directoryPrefix,
            uploadedDriveFilesCount,
            fileType
          );

          console.log(tempFile);

          newFileRef.set(tempFile);
        });
      });
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
  }
}
</script>

<style>
.inline-obj {
  display: inline;
}
</style>